import Header from '@components/Header';
import styled from '@emotion/styled';
import useItem from '@hooks/item/useItem';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import TextOption from '../_shared/components/TextOption';

interface Params {
    itemId: string;
}

const PersonalOptionActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { itemId } = params;
    const item = useItem(itemId);
    const { t } = useTranslation('item');
    return (
        <AppScreen>
            <Header title={t('option.personal')} />
            <Contents>
                {item?.personalOptionGroups.map((optionGroup, idx) => (
                    <TextOption
                        optionGroup={optionGroup}
                        noDivider={idx === 0}
                        key={optionGroup.optionGroupId}
                        itemId={itemId} />
                ))}
            </Contents>
        </AppScreen>
    );
};

const Contents = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 48px;
`;

export default PersonalOptionActivity;
